import Element from "./index";
import { RouteType } from "routes/types";

const route: RouteType = {
  id: 1220,
  parentId: 1200,
  name: "Platform",
  label: "Platform",
  path: "platform",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: true,
};

export default route;
